import * as React from "react";
import { NGButton } from "../../../newcomponents/button/Button";
import { useFormContext } from "react-hook-form";
import { ViewModal } from "../../../components/modals/viewModal";
import { DomainInput } from "./types/input";
import { inputToDomain } from "./utils/utils";

export const CreateNGPreview: React.FC = () => {
  const { getValues } = useFormContext<DomainInput>();

  const [isPreviewing, setIsPreviewing] = React.useState(false);

  return (
    <>
      <NGButton variant="secondary" outlined className="w-full" type={`button`} onClick={() => setIsPreviewing(true)}>
        Preview
      </NGButton>
      {isPreviewing ? (
        <ViewModal
          kind="domain"
          onClose={() => setIsPreviewing(false)}
          title="Domain"
          object={inputToDomain(getValues())}
          visible={isPreviewing}
          filename={`test`}
          initialFormat={`yaml`}
        />
      ) : null}
    </>
  );
};
